import React from "react";
import PropTypes from "prop-types";

import communicateServer0Icon from "../../Img/communicateServer0.png";
import communicateServer1Icon from "../../Img/communicateServer1.png";
import communicateServer2Icon from "../../Img/communicateServer2.png";
import communicateServer3Icon from "../../Img/communicateServer3.png";

class TWifiAnimation extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        style: PropTypes.object,
    };

    static defaultProps = {
        style: {},
    };

    constructor(props) {
        super(props);

        this.timer = null;

        this.state = {
            frame: 0,
        };
    }

    componentDidMount() {
        this.timer = setInterval(() => {
            const moo = (this.state.frame + 1) % 4;
            this.setState({
                frame: moo,
            });
        }, 500);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        let icon = null;

        switch (this.state.frame) {
            case 0:
                icon = communicateServer0Icon;
                break;

            case 1:
                icon = communicateServer1Icon;
                break;

            case 2:
                icon = communicateServer2Icon;
                break;

            case 3:
                icon = communicateServer3Icon;
                break;

            default:
                icon = null;
        }

        return (
            <img
                src={icon}
                style={this.props.style}
                alt={""}
            />
        );
    }
}

export default TWifiAnimation;
